export default function SecondaryButton({ title, toggleModal }) {
  return (
    <>   
    <button
    className="relative inline-flex items-center justify-center max-w-[280px]  animate-cta-btn w-full py-3 px-4 overflow-hidden font-semibold text-white transition-all duration-150 ease-in-out rounded-full hover:bg-[linear-gradient(45deg,#f13a00_0%,#FF9A3E_100%)] bg-[linear-gradient(90deg,#F16500_0%,#FF9A3E_100%)] group1 w-full"
    onClick={toggleModal}
  >
    {/* <span className="absolute right-10 pr-4 duration-200 ease-out group-hover:translate-x-[100px]">
      <svg
        className="w-4 h-4 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14 5l7 7m0 0l-7 7m7-7H3"
        />
      </svg>
    </span>
    <span className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-10 ease-out duration-200">
      <svg
        className="w-4 h-4 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14 5l7 7m0 0l-7 7m7-7H3"
        />
      </svg>
    </span> */}
    <span className="relative w-full font-medium text-center leading-loose transition-colors duration-200 ease-in-out group-hover:text-white block text-center">
      {title}
    </span>
  </button>
    </>
  );
}
